<template>
  <v-card
    flat
  >
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-combobox
          v-model="substance"
          :items="substances"
          label="Goods"
          :filter="comboFilter"
          outlined
          clearable
          dense
          item-text="name"
          prepend-icon=""
          :rules="goodsRules"
        ></v-combobox>
        <v-row>
          <v-col cols="2">
            <v-radio-group
              v-model="classification"
              label="Classification"
            >
              <v-radio
                v-for="item in classes"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="4">
            <v-switch
              v-model="full"
              label="Full charged"
              @change="fullChange"
            ></v-switch>
            <v-text-field
              v-model.number="load"
              pattern="[1-9]"
              suffix="ton"
              type="number"
              step="1"
              outlined
              dense
              ref="load"
              label="Charge"
              :rules="loadRules"
              @keydown="keyDown"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapState } from "vuex";
  import store from "../store";
  export default {
    name: 'Goods',

    data: () => ({
      valid: true,
      full: false,
      goodsRules: [
        v => !!v || "Goods is required"
      ],
      loadRules: [
        v => !!v || "Charge is required",
        v => v <= store.state.input.tonnage || "Overload!"
      ]
    }),
    computed: {
      ...mapState({
        substances: state => state.static.substances,
        classes: state => state.static.classes,
      }),
      load: {
        get() {
          return this.$store.state.input.amount;
        },
        set(value) {
          if (value == this.$store.state.input.tonnage) {
            this.full = true;
          }
          else if (value < this.$store.state.input.tonnage){
            this.full = false;
          }
          this.$store.commit("setAmount", value);
        }
      },
      classification: {
        get() {
          return this.$store.state.input.classification;
        },
        set(value) {
          this.$store.commit("setClassification", value);
        }
      },
      substance: {
        get() {
          return this.$store.state.input.substance;
        },
        set(value) {
          if (value) {
            this.classification = value.classification;
          }
          this.$store.commit("setSubstance", value);
        }
      }
    },
    methods: {
      save: function() {
        localStorage.setItem("ces-state", JSON.stringify(this.$store.state.input));
      },
      resetValidation: function() {
        this.$refs.form.resetValidation();
      },
      comboFilter: function(item, filterText, itemText) {
        return itemText.startsWith(filterText);
      },
      fullChange: function(v) {
        if (v) {
          this.load = this.$store.state.input.tonnage;
          this.full = true;
        }
        else {
          this.load = this.$store.state.input.amount;
          this.full = false;
        }
      },
      keyDown: function(e) {
        console.log(e);
        if ((/^[a-z,A-Z]$/i.test(event.key))) {
          e.preventDefault(true);
        }
      }
    }
  }
</script>
